(function(window, angular){'use strict';

var ngModule = angular.module('pp.widgets.invest-dialog-recaptcha-failed', ['pp.widgets-templates']);

ngModule.component('ppInvestDialogRecaptchaFailed', {
    templateUrl: 'widgets/_angular/invest-dialog-recaptcha-failed/invest-dialog-recaptcha-failed.tpl.html',
    bindings: {},
    controllerAs: 'vm',
    controller: ['$scope', '$window', 'ppTrack', function ($scope, $window, ppTrack) {
        var vm = this;

        // -- initial state

        // -- util functions

        // -- api
        vm.reloadPage = function () {
            ppTrack.deferAction('invest.recaptcha-failed.retry');
            $window.location.reload();
        };

        // -- scope bindings

        // -- main

    }]
});
})(window, window.angular);